
import { useEffect } from 'react';
import { useSidebar } from '@/components/ui/sidebar';

/**
 * Hook personalizado para demonstrar a persistência da sidebar
 * Adiciona logs úteis para debug e feedback do usuário
 */
export const useSidebarPersistence = () => {
  const { state, open } = useSidebar();

  useEffect(() => {
    // Log quando o estado da sidebar muda
    console.log(`🔧 Sidebar ${state === 'expanded' ? 'expandida' : 'minimizada'} - Preferência salva no localStorage`);
  }, [state]);

  useEffect(() => {
    // Log inicial quando o componente carrega
    const savedState = localStorage.getItem('sidebar:state');
    if (savedState !== null) {
      console.log(`💾 Preferência da sidebar carregada do localStorage: ${savedState === 'true' ? 'expandida' : 'minimizada'}`);
    } else {
      console.log('🆕 Primeira visita - usando estado padrão da sidebar');
    }
  }, []);

  return { state, open };
};
